import React from 'react';
import { getMessage } from '@tcc/i18n';
import { Nullable } from '@tcc/common';
import { SummaryItem } from './SummaryItem';
import { ReportMeasurement } from '../../../../types';
import styles from '../RegionReport.css';
import { getLocalizedArea, getLocalizedAverageYield, getLocalizedMoisture, getLocalizedTotalWeight } from '../frrStatsFormat';

export type RegionReportSummaryProps = {
  area: ReportMeasurement;
  averageMoisture: ReportMeasurement;
  averageYield: ReportMeasurement;
  totalWeight: ReportMeasurement;
  averageYieldText: string;
  withDryMatterYield: boolean;
  cropCode: string;
  cropNominalWeight?: Nullable<number>;
};

export const RegionReportSummary = ({
  averageYield,
  averageYieldText,
  totalWeight,
  area,
  averageMoisture,
  withDryMatterYield,
  cropCode,
  cropNominalWeight
}: RegionReportSummaryProps) => {
  const totalWeightLabelKeySuffix = withDryMatterYield ? 'totalDryWeight' : 'totalWeight';
  const totalWeightLabelKey = `regions.report.modal.${totalWeightLabelKeySuffix}`;

  const localizedArea = getLocalizedArea(area);
  const localizedMoisture = getLocalizedMoisture(cropCode, averageMoisture);
  const localizedAverageYield = getLocalizedAverageYield(cropCode, averageYield, cropNominalWeight);
  const localizedTotalWeight = getLocalizedTotalWeight({
    cropCode,
    totalWeight,
    cropNominalWeight
  });

  return (
    <div className={styles.summaryDashboard} data-test-id="frr-summary-title">
    <h2 className={styles.summaryTitle} >
      {getMessage('regions.report.modal.summaryTitle')}
    </h2>
    <div className={styles.summaryTotals} data-test-id="frr-summary-totals">
      <SummaryItem
        localizedMeasurement={localizedArea}
        label={getMessage('regions.report.modal.areaHarvested')}
        dataTestId="harvested" />

      { localizedMoisture && (
        <SummaryItem
          localizedMeasurement={localizedMoisture}
          label={getMessage('regions.report.modal.averageMoisture')}
          dataTestId="moisture" />
      )}

      <SummaryItem
        localizedMeasurement={localizedAverageYield}
        label={averageYieldText}
        dataTestId='avg-yield-text' />

      { localizedTotalWeight && (
        <SummaryItem
          localizedMeasurement={localizedTotalWeight}
          label={getMessage(totalWeightLabelKey)}
          dataTestId='total-weight' />
      )}
    </div>
  </div>
  )
};
